import api from "./client";

const BASE = "/alerts";

/**
 * Fetch alerts with filters
 * @param {Object} filters
 * @returns {Promise<{data: Array}>} Resolves with grouped student alerts response
 */
export async function fetchAlerts(filters = {}) {
  const { data } = await api.post(`${BASE}/query`, filters);

  return data;
}

/**
 * Mark single alert as read
 * @param {string} alertId
 * @returns {Promise<{alertId: string}>} Resolves with updated alert ID
 */
export async function markAlertRead(alertId) {
  const { data } = await api.patch(`${BASE}/${alertId}/read`);

  return data;
}

/**
 * Mark a single alert as unread
 *
 * @param {string} alertId - The ID of the alert to mark as unread
 * @returns {Promise<{alertId: string}>} Resolves with updated alert ID
 */
export async function markAlertUnread(alertId) {
  const { data } = await api.patch(`${BASE}/${alertId}/unread`);

  return data;
}

/**
 * Mark all alerts as read using optional filters
 * @param {Object} filters - Optional filters to scope which alerts are marked as read
 * @returns {Promise<void>} Resolves when operation completes
 */
export async function markAllAlertsRead(studentId) {
  const { data } = await api.post(`${BASE}/mark-all-read`, { studentId });

  return data;
}
